var _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrowDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48pt",
    height: "48pt",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5",
    mask: "url(#mask0)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(70%, 70%, 70%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 25.71167 30.919189 L 18.153076 22.5 L 25.71167 14.084473 ",
    transform: "matrix(1.066667,0,0,1.066667,0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowDisable);
export default __webpack_public_path__ + "static/media/BackArrowDisable.0af834d4ae43b3fff6069fdb5ac5f57c.svg";
export { ForwardRef as ReactComponent };